<template>
  <v-navigation-drawer
    v-if="isSendEmailAccountCreateDrawerOpen"
    :value="isSendEmailAccountCreateDrawerOpen"
    @input="inputSendEmailAccountCreateDrawer"
    width="45%"
    temporary
    fixed
    right
    color="grey lighten-3"
    style="transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1)"
  >
    <BaseToolbar
      :button-save="true"
      color="#2661FF"
      :dark="true"
      @close="close"
      @save="submit"
      :loader-save="loading"
      :title="$t('organization.details.tabs.integrations.amazon_ses.title')"
      type-title="icon"
      icon="edit"
    />

    <v-row class="pa-4">
      <v-col cols="12" class="mt-6">
        <h2 class="title text_color d-flex justify-center">
          Crea una cuenta de envío de correos
        </h2>
      </v-col>
      <v-col cols="12">
        <v-card class="custom_card" flat>
          <v-card-title class="justify-center">
            <p class="body-2 text_color" style="word-break: keep-all;">
              Aquí podrás crear una cuenta de envío de correos utilizando las
              credenciales de Amazon Web Services.
            </p>
          </v-card-title>
          <v-card-text>
            <v-form ref="credentials-form">
              <v-row no-gutters>
                <!------------------------------------------>
                <!-- NAME ---------------------------------->
                <!------------------------------------------>
                <v-col cols="12">
                  <label for="name" class="text_color">
                    Nombre
                  </label>
                  <v-text-field
                    id="name"
                    v-model="credentials.name"
                    :rules="[rules.required]"
                    class="rounded-lg"
                    placeholder="Nombre"
                    outlined
                    dense
                    clearable
                  />
                </v-col>
                <!------------------------------------------>
                <!-- ACCESS KEY ID ------------------------->
                <!------------------------------------------>
                <v-col cols="12">
                  <label for="awsAccessKeyId" class="text_color">
                    Access Key ID
                  </label>
                  <v-text-field
                    id="awsAccessKeyId"
                    v-model="credentials.awsAccessKeyId"
                    :rules="[rules.required]"
                    class="rounded-lg"
                    placeholder="Access Key ID"
                    outlined
                    dense
                    clearable
                  />
                </v-col>
                <!------------------------------------------>
                <!-- ACCESS KEY SECRET --------------------->
                <!------------------------------------------>
                <v-col cols="12">
                  <label for="awsSecretAccessKey" class="text_color">
                    Access Key Secret
                  </label>
                  <v-text-field
                    id="awsSecretAccessKey"
                    v-model="credentials.awsSecretAccessKey"
                    :rules="[rules.required]"
                    class="rounded-lg"
                    placeholder="Access Key Secret"
                    outlined
                    dense
                    clearable
                  />
                </v-col>
                <!------------------------------------------>
                <!-- REGION -------------------------------->
                <!------------------------------------------>
                <v-col cols="12">
                  <label for="region" class="text_color">
                    Region
                  </label>
                  <v-autocomplete
                    id="region"
                    v-model="credentials.awsRegion"
                    :items="regions"
                    :rules="[rules.required]"
                    class="rounded-lg"
                    placeholder="Region"
                    outlined
                    dense
                    clearable
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import BaseToolbar from '../../BaseToolbar.vue'

export default {
  name: 'CreateSendEmailAccount',
  components: {
    BaseToolbar
  },
  data() {
    return {
      loading: false,
      credentials: {
        name: null,
        awsAccessKeyId: null,
        awsSecretAccessKey: null,
        awsRegion: null
      },
      rules: {
        required: value => !!value || 'Campo requerido'
      }
    }
  },
  computed: {
    ...mapState({
      isSendEmailAccountCreateDrawerOpen: ({ onboarding: { aws } }) =>
        aws.isSendEmailAccountCreateDrawerOpen,
      regions: ({ onboarding: { aws } }) => aws.regions
    })
  },
  methods: {
    ...mapActions({
      createSendEmailAccount: 'onboarding/createSendEmailAccount'
    }),
    ...mapMutations({
      toggleSendEmailAccountCreateDrawer:
        'onboarding/toggleSendEmailAccountCreateDrawer'
    }),
    inputSendEmailAccountCreateDrawer(arg) {
      if (!arg) {
        this.toggleSendEmailAccountCreateDrawer(false)
      }
    },
    close() {
      this.toggleSendEmailAccountCreateDrawer(false)
    },
    async submit() {
      const valid = this.$refs['credentials-form'].validate()

      if (!valid) return

      this.loading = true
      const { success } = await this.createSendEmailAccount(this.credentials)
      this.loading = false

      if (success) {
        this.toggleSendEmailAccountCreateDrawer(false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom_card {
  border-radius: 12px !important;
  border: 1px solid #d0d3db !important;
}
.text_color {
  color: #344054 !important;
}
</style>
